<div>
  <label for="bank-select">Selecciona un banco</label>
  <select
  class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all "
    id="bank-select"
    [(ngModel)]="selectedBankModel"
    (ngModelChange)="onSelectBank($event)"
  >
    @for (bank of banks(); track bank.id_banco) {
    <option [ngValue]="bank">{{ bank.Nombre }}</option>
    }
  </select>
</div>
